import { Component, OnInit } from '@angular/core';
import { DashboardService } from '../../services/dashboard.service';
import { PreloginService } from '../../services/prelogin.service';

@Component({
  selector: 'app-my-dashboard',
  templateUrl: './my-dashboard.component.html',
  styleUrls: ['./my-dashboard.component.scss']
})
export class MyDashboardComponent implements OnInit {

  loggedInUserDetails;
  userRole;
  userRoleName;

  constructor(private dashboardService: DashboardService, private preloginService: PreloginService) { }

  ngOnInit() {

    this.loggedInUserDetails = this.dashboardService.decodeToken();

    console.log('dashboard', this.loggedInUserDetails);

    // 0 - Partner, 1 - Admin, 2 - Counsellor
    this.userRole = this.preloginService.getCurrentRole();
    if (this.userRole === 0) {
      this.userRoleName = 'Partner';
    } else if (this.userRole === 1) {
      this.userRoleName = 'Admin';
    } else if (this.userRole === 2) {
      this.userRoleName = 'Counsellor';
    }
  }

}
